import '../components/accordion/accordion.js';
import '../components/giftcard-selection/giftcard-selection.element.js';
import '../components/tooltip/tooltip.js';
import '../components/modal/modal.js';
import StickyScroller from './lib/sticky-scroller.js';
import {trackClassicGiftcardLink, trackCubePageViewGiftCard} from "../components/tracking/trackingLayer.js";

interface Modal {
  show: () => void
}

new StickyScroller('.ents-giftcard-details__content', '.ents-giftcard-details__sidebar--wrapper-sticky'); // NOSONAR

document.addEventListener('DOMContentLoaded', () => setTimeout(() => {
  const errorModal = document.querySelector('#ents-giftcard-error-modal') as unknown as Modal;
  errorModal?.show();
  // rewrite url to remove error param
  const url = new URL(window.location.href);
  if (url.searchParams.has('error')) {
    url.searchParams.delete('error');
    window.history.replaceState({}, document.title, url.toString());
  }

  const classicGiftcardLink = document.querySelector('.ents-classic-giftcard-link');
  if (classicGiftcardLink) {
    classicGiftcardLink.addEventListener('click', () => {
      trackClassicGiftcardLink();
    });
  }
}, 100));

trackCubePageViewGiftCard();
